// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { V1RollStrategy } from './V1RollStrategy';
import {
  V1RollStrategyFromJSON,
  V1RollStrategyFromJSONTyped,
  V1RollStrategyToJSON,
  V1RollStrategyToJSONTyped,
} from './V1RollStrategy';
import type { V1CDCEnrichmentMode } from './V1CDCEnrichmentMode';
import {
  V1CDCEnrichmentModeFromJSON,
  V1CDCEnrichmentModeFromJSONTyped,
  V1CDCEnrichmentModeToJSON,
  V1CDCEnrichmentModeToJSONTyped,
} from './V1CDCEnrichmentMode';
import type { V1SpdConfig } from './V1SpdConfig';
import {
  V1SpdConfigFromJSON,
  V1SpdConfigFromJSONTyped,
  V1SpdConfigToJSON,
  V1SpdConfigToJSONTyped,
} from './V1SpdConfig';
import type { V1LogicalRestrictionsSettings } from './V1LogicalRestrictionsSettings';
import {
  V1LogicalRestrictionsSettingsFromJSON,
  V1LogicalRestrictionsSettingsFromJSONTyped,
  V1LogicalRestrictionsSettingsToJSON,
  V1LogicalRestrictionsSettingsToJSONTyped,
} from './V1LogicalRestrictionsSettings';
import type { V1BackupSettings } from './V1BackupSettings';
import {
  V1BackupSettingsFromJSON,
  V1BackupSettingsFromJSONTyped,
  V1BackupSettingsToJSON,
  V1BackupSettingsToJSONTyped,
} from './V1BackupSettings';

/**
 *
 * @export
 * @interface V1AdditionalSettings
 */
export interface V1AdditionalSettings {
  /**
   *
   * @type {boolean}
   * @memberof V1AdditionalSettings
   */
  alwaysSkipConsistency?: boolean;
  /**
   *
   * @type {V1BackupSettings}
   * @memberof V1AdditionalSettings
   */
  backup?: V1BackupSettings;
  /**
   *
   * @type {V1CDCEnrichmentMode}
   * @memberof V1AdditionalSettings
   */
  cdcEnrichmentMode?: V1CDCEnrichmentMode;
  /**
   *
   * @type {boolean}
   * @memberof V1AdditionalSettings
   */
  disableDefaultDb?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof V1AdditionalSettings
   */
  disableDefaultUser?: boolean;
  /**
   *
   * @type {V1LogicalRestrictionsSettings}
   * @memberof V1AdditionalSettings
   */
  logicalRestrictions?: V1LogicalRestrictionsSettings;
  /**
   *
   * @type {Array<string>}
   * @memberof V1AdditionalSettings
   */
  plugins?: Array<string>;
  /**
   *
   * @type {V1RollStrategy}
   * @memberof V1AdditionalSettings
   */
  rollStrategy?: V1RollStrategy;
  /**
   *
   * @type {boolean}
   * @memberof V1AdditionalSettings
   */
  rollWithoutSeeding?: boolean;
  /**
   *
   * @type {V1SpdConfig}
   * @memberof V1AdditionalSettings
   */
  spdConfig?: V1SpdConfig;
  /**
   *
   * @type {boolean}
   * @memberof V1AdditionalSettings
   */
  spdEnabled?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof V1AdditionalSettings
   */
  vectorOptimized?: boolean;
}

/**
 * Check if a given object implements the V1AdditionalSettings interface.
 */
export function instanceOfV1AdditionalSettings(
  value: object,
): value is V1AdditionalSettings {
  return true;
}

export function V1AdditionalSettingsFromJSON(json: any): V1AdditionalSettings {
  return V1AdditionalSettingsFromJSONTyped(json, false);
}

export function V1AdditionalSettingsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1AdditionalSettings {
  if (json == null) {
    return json;
  }
  return {
    alwaysSkipConsistency:
      json['alwaysSkipConsistency'] == null
        ? undefined
        : json['alwaysSkipConsistency'],
    backup:
      json['backup'] == null
        ? undefined
        : V1BackupSettingsFromJSON(json['backup']),
    cdcEnrichmentMode:
      json['cdcEnrichmentMode'] == null
        ? undefined
        : V1CDCEnrichmentModeFromJSON(json['cdcEnrichmentMode']),
    disableDefaultDb:
      json['disableDefaultDb'] == null ? undefined : json['disableDefaultDb'],
    disableDefaultUser:
      json['disableDefaultUser'] == null
        ? undefined
        : json['disableDefaultUser'],
    logicalRestrictions:
      json['logicalRestrictions'] == null
        ? undefined
        : V1LogicalRestrictionsSettingsFromJSON(json['logicalRestrictions']),
    plugins: json['plugins'] == null ? undefined : json['plugins'],
    rollStrategy:
      json['rollStrategy'] == null
        ? undefined
        : V1RollStrategyFromJSON(json['rollStrategy']),
    rollWithoutSeeding:
      json['rollWithoutSeeding'] == null
        ? undefined
        : json['rollWithoutSeeding'],
    spdConfig:
      json['spdConfig'] == null
        ? undefined
        : V1SpdConfigFromJSON(json['spdConfig']),
    spdEnabled: json['spdEnabled'] == null ? undefined : json['spdEnabled'],
    vectorOptimized:
      json['vectorOptimized'] == null ? undefined : json['vectorOptimized'],
  };
}

export function V1AdditionalSettingsToJSON(json: any): V1AdditionalSettings {
  return V1AdditionalSettingsToJSONTyped(json, false);
}

export function V1AdditionalSettingsToJSONTyped(
  value?: V1AdditionalSettings | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    alwaysSkipConsistency: value['alwaysSkipConsistency'],
    backup: V1BackupSettingsToJSON(value['backup']),
    cdcEnrichmentMode: V1CDCEnrichmentModeToJSON(value['cdcEnrichmentMode']),
    disableDefaultDb: value['disableDefaultDb'],
    disableDefaultUser: value['disableDefaultUser'],
    logicalRestrictions: V1LogicalRestrictionsSettingsToJSON(
      value['logicalRestrictions'],
    ),
    plugins: value['plugins'],
    rollStrategy: V1RollStrategyToJSON(value['rollStrategy']),
    rollWithoutSeeding: value['rollWithoutSeeding'],
    spdConfig: V1SpdConfigToJSON(value['spdConfig']),
    spdEnabled: value['spdEnabled'],
    vectorOptimized: value['vectorOptimized'],
  };
}
